import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import moment from 'moment';
import _ from 'lodash';

@Component({
    selector: 'app-part-types-select-dialog',
    templateUrl: './part-types-select-dialog.component.html',
    styleUrls: ['./part-types-select-dialog.component.scss'],
    standalone: false
})
export class PartTypesSelectDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    selectedPartTypeIds: any[];
    partTypes: any[];

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService, private modalService: BsModalService) { }

    async ngOnInit() {
        this.partTypes = _(await this.uow.partTypes.whereActive()).sortBy('name').valueOf();
        if (!this.selectedPartTypeIds)
            this.selectedPartTypeIds = [];
    }

    async save() {
        this.result.next({ success: true, partTypeIds: this.selectedPartTypeIds });
        this.modalRef.hide();
    }

    add() {
        this.result.next({ add: true, partTypeIds: this.selectedPartTypeIds });
        this.modalRef.hide();
    }

    delete() {
        this.result.next({ delete: true, partTypeIds: this.selectedPartTypeIds });
        this.modalRef.hide();
    }

    cancel() {
        this.modalRef.hide();
    }
}
